import { ApplicationEnvironment } from './application-environment.interface';

const packageJson = require( '../../package.json' );

export const environment: ApplicationEnvironment = {
  version: packageJson.version,
  name: packageJson.name,
  production: true,
  useMock: false,
  configEndPoint: '/iq/api/config/'
};
